import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "app/modules/shared/services/translate/translate.service";

@Component({
  selector: "kl-register",
  templateUrl: "./confirm-password.component.html",
  styleUrls: ["./confirm-password.component.scss"],
})
export class ConfirmPasswordComponent implements OnInit {
  selectedLanguage: string;
  errorStatus: boolean;
  successStatus: boolean;
  user = {
    password: "",
    password_confirmation: "",
  };

  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,
    private _translate: TranslateService
  ) {}

  ngOnInit() {
    if (localStorage.getItem("currentLanguage")) {
      this.selectedLanguage = localStorage.getItem("currentLanguage");
    } else {
      this.selectedLanguage = "tr";
    }
    this.selectLang(this.selectedLanguage);
  }

  selectLang(lang: string) {
    this._translate.useCulture(lang);
    this._translate.use(lang);
  }

  onSubmit() {
    if (this.user.password !== this.user.password_confirmation) {
      this.errorStatus = true;
      this.successStatus = false;
    } else {
      this.errorStatus = false;
      this.successStatus = true;
      this.router.navigateByUrl("/auth/login");
    }
  }
}
